export const Reactions = {
  Heart: { value: 'heart', name: '❤️' },
  Star: { value: 'star', name: '⭐' },
  ThumbUp: { value: 'thumbUp', name: '👍' },
  ThumbDown: { value: 'thumbDown', name: '👎' },
  Hooray: { value: 'hooray', name: '🎉' },
  Eyes: { value: 'hooray', name: '👀' },
  Laugh: { value: 'laugh', name: '😄' },
  Confused: { value: 'confused', name: '😕' },
};



// WEBPACK FOOTER //
// ./src/models/survey/Reactions.js